import {
  Layout,
  Row,
  Col,
  Dropdown,
  Avatar,
  Form,
  Image,
  Button,
  Drawer,
  Divider,
  Modal,
  Input,
  message,
  Menu,
} from "antd";
import {
  UserOutlined,
  MenuOutlined,
  LogoutOutlined,
  LockOutlined,
  GlobalOutlined,
} from "@ant-design/icons";
import { useAuth } from "../utils/Auth/AuthWrapper";
import { useRecoilState } from "recoil";
import { languageState, localeState, themeState } from "../utils/atoms";
import { useTranslation } from "react-i18next";
import enUS from "antd/locale/en_US";
import thTH from "antd/locale/th_TH";
import { useEffect, useState, useMemo } from "react";
import { getMenuSider } from "../config/menu/configMenu";
import Profile from "../components/Profile";
import config from "../config/config";
import { get_profile, user_login } from "../services/user";
import { useNavigate, useLocation } from "react-router-dom";
import "../layout/index.less";
import LogoBg from "../assets/images/logo/benchmarklogo.webp";
import LogoWhite from "../assets/images/logo/logo-sharedTask1.webp";
import Logobentch from "../assets/images/logo/benchmarklogo.webp";
import Notification from "../views/Notification";
import { useSocket } from "../utils/socketio/SocketWrapper";

interface UserData {
  user_name: string;
  org_name: string;
  user_email: string;
  profile_img: string;
  role_name: string;
}

type Props = {
  isTokenExpired: boolean;
};

const HeaderLayout = ({ isTokenExpired }: Props) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { Header } = Layout;
  const auth = useAuth();
  const { socket, logoutSocket }: any = useSocket();

  // Profile state (used when logged in)
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [passwordFormVisible, setPasswordFormVisible] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [userData, setUser] = useState<UserData>({
    user_name: "",
    org_name: "",
    user_email: "",
    profile_img: "",
    role_name: "",
  });

  // Login state (used when not logged in)
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [loginForm] = Form.useForm();

  // Shared state
  const [language, setLanguage] = useRecoilState(languageState);
  const [locale, setLocale] = useRecoilState(localeState);
  const { i18n, t } = useTranslation();
  const [themeMode, setThemeMode] = useRecoilState(themeState);
  const [activeLanguage, setActiveLanguage] = useState("enUS");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [typeModal, setTypeModal] = useState(1);

  const reqPic = config.api_backend + "/pic/";

  // Navigation menu (moved from SiderLayout)
  const location = useLocation();
  const [menuItems, setMenuItems] = useState<any[]>([]);
  const menu = useMemo(() => getMenuSider(), [menuItems, language]);

  useEffect(() => {
    const loadMenu = async () => {
      try {
        const res = await getMenuSider();
        setMenuItems(res);
      } catch (error) {
        console.error("Error fetching menu:", error);
      }
    };
    loadMenu();
  }, [isTokenExpired]);

  useEffect(() => {
    if (!isTokenExpired && socket.current) {
      socket.current.on("updaterole", (data: any) => {
        if (auth.user.user_id == data.user_id) {
          if (data.type == 1) {
            let user = {
              accessToken:
                "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjpudWxsLCJyb2xlX2lkIjoiYTQyZjVjOTktMjkxYS0xMWVmLThjMzYtMDI0MmFjMTUwMDA2Iiwib3JnX2lkIjoiZTgyZmI3ZjMtM2ZhMC00NDZkLThlZjQtOTc0MzQyMWI0Y2E4IiwiaWF0IjoxNzE4NzY2NzIzLCJleHAiOjE3MTkwMjU5MjN9.QnseLdlu9O9BQQKhjXizXc_AgaFQATS2tCxHpSeeQzc",
              user_status: 1,
              user_id: null,
              user_name: null,
              profile_img: null,
              org_id: "e82fb7f3-3fa0-446d-8ef4-9743421b4ca8",
              org_name: "Ai9",
              role: "User",
              token:
                "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjpudWxsLCJyb2xlX2lkIjoiYTQyZjVjOTktMjkxYS0xMWVmLThjMzYtMDI0MmFjMTUwMDA2Iiwib3JnX2lkIjoiZTgyZmI3ZjMtM2ZhMC00NDZkLThlZjQtOTc0MzQyMWI0Y2E4IiwiaWF0IjoxNzE4NzY2NzIzLCJleHAiOjE3MTkwMjU5MjN9.QnseLdlu9O9BQQKhjXizXc_AgaFQATS2tCxHpSeeQzc",
              expiresIn: null,
            };
            localStorage.setItem("stt", JSON.stringify(user));
            setTypeModal(data.type);
            setIsModal(true);
          } else if (data.type == 2) {
            let screenpath = window.location.pathname.split("/");
            if (screenpath[1] == "task" || screenpath[1] == "score") {
              setTypeModal(data.type);
              setIsModal(true);
            }
          }
        }
      });
    }
  }, [socket.current, isTokenExpired]);

  useEffect(() => {
    if (!isTokenExpired) {
      let userInfo: any = localStorage.getItem("stt");
      let user = JSON.parse(userInfo);
      if (user.role != "User") {
        getProfile();
      }
    }

    const storedLocale = localStorage.getItem("locale") || "enUS";
    if (storedLocale === "thTH") {
      i18n.changeLanguage("thTH");
      setLocale(thTH);
      setLanguage("thTH");
      setActiveLanguage("thTH");
    } else {
      i18n.changeLanguage("enUS");
      setLocale(enUS);
      setLanguage("enUS");
      setActiveLanguage("enUS");
    }

    const storedTheme = localStorage.getItem("themeMode") || "light";
    setThemeMode(storedTheme);
  }, [i18n, setLocale, setLanguage, setThemeMode, isTokenExpired]);

  const getProfile = async () => {
    try {
      const res = await get_profile();
      const user = res.result;
      setUser(user[0]);
    } catch (error) {
      console.error(error);
    }
  };

  const onChangeLanguage = (lang: any) => {
    if (lang === "thTH") {
      i18n.changeLanguage("thTH");
      setLocale(thTH);
      setLanguage("thTH");
      localStorage.setItem("locale", "thTH");
    } else {
      i18n.changeLanguage("enUS");
      setLocale(enUS);
      setLanguage("enUS");
      localStorage.setItem("locale", "enUS");
    }
    setActiveLanguage(lang);
  };

  const handleLogin = async (value: any) => {
    setSubmitting(true);
    try {
      const data = {
        user_email: value.email,
        password: value.password,
      };
      const res = await user_login(data);

      if (res.message == "success" && res.status == 1) {
        auth.login(res.result);
        window.location.reload();
      } else if (res.message == "failed: user not found") {
        loginForm.setFields([
          { name: "email", errors: ["ไม่มีผู้ใช้นี้ในระบบ"] },
        ]);
      } else {
        loginForm.setFields([{ name: "email", errors: [res.error_message] }]);
      }
    } catch (e) {
      console.error(e);
      message.error("Email or password is incorrect, please try again !");
    }
    setSubmitting(false);
  };

  const handleClickModal = async () => {
    try {
      navigate("/");
      setIsModal(false);
    } catch (e) {
      console.error(e);
    }
  };

  // --- OLD dropdownItems (Profile + Logout only) ---
  // const dropdownItems = [
  //   {
  //     key: "1",
  //     label: <a onClick={() => setIsProfileOpen(true)}>{t("Profile")}</a>,
  //   },
  //   {
  //     key: "2",
  //     label: (
  //       <a
  //         onClick={() => {
  //           logoutSocket();
  //           auth.logout();
  //         }}
  //       >
  //         {t("Logout")}
  //       </a>
  //     ),
  //   },
  // ];

  // --- NEW dropdownItems (Language + Profile + Logout) ---
  const dropdownItems = [
    {
      key: "lang-th",
      label: (
        <span
          onClick={() => onChangeLanguage("thTH")}
          style={{
            fontWeight: activeLanguage === "thTH" ? "bold" : "normal",
            color: activeLanguage === "thTH" ? "#BC224A" : "inherit",
          }}
        >
          🇹🇭 ภาษาไทย (TH)
        </span>
      ),
    },
    {
      key: "lang-en",
      label: (
        <span
          onClick={() => onChangeLanguage("enUS")}
          style={{
            fontWeight: activeLanguage === "enUS" ? "bold" : "normal",
            color: activeLanguage === "enUS" ? "#BC224A" : "inherit",
          }}
        >
          🇺🇸 English (EN)
        </span>
      ),
    },
    { type: "divider" as const },
    {
      key: "1",
      label: <a onClick={() => setIsProfileOpen(true)}>{t("Profile")}</a>,
    },
    {
      key: "2",
      label: (
        <a
          onClick={() => {
            logoutSocket();
            auth.logout();
          }}
        >
          {t("Logout")}
        </a>
      ),
    },
  ];

  // --- OLD LanguageSelector (text style: TH | EN) ---
  // const LanguageSelector = () => (
  //   <div>
  //     <span
  //       onClick={() => onChangeLanguage("thTH")}
  //       style={{
  //         color: activeLanguage === "thTH" ? "#BC224A" : "black",
  //         fontWeight: "bold",
  //         fontSize: "20px",
  //         cursor: "pointer",
  //       }}
  //     >
  //       TH
  //     </span>
  //     <span style={{ margin: "0 8px", fontSize: "20px" }}>|</span>
  //     <span
  //       onClick={() => onChangeLanguage("enUS")}
  //       style={{
  //         color: activeLanguage === "enUS" ? "#BC224A" : "black",
  //         fontWeight: "bold",
  //         fontSize: "20px",
  //         cursor: "pointer",
  //       }}
  //     >
  //       EN
  //     </span>
  //   </div>
  // );

  // --- NEW LanguageSelectorIcon (globe icon + dropdown) ---
  const LanguageSelectorIcon = () => {
    const langItems = [
      {
        key: "thTH",
        label: (
          <span
            onClick={() => onChangeLanguage("thTH")}
            style={{
              fontWeight: activeLanguage === "thTH" ? "bold" : "normal",
              color: activeLanguage === "thTH" ? "#BC224A" : "inherit",
            }}
          >
            🇹🇭 ภาษาไทย (TH)
          </span>
        ),
      },
      {
        key: "enUS",
        label: (
          <span
            onClick={() => onChangeLanguage("enUS")}
            style={{
              fontWeight: activeLanguage === "enUS" ? "bold" : "normal",
              color: activeLanguage === "enUS" ? "#BC224A" : "inherit",
            }}
          >
            🇺🇸 English (EN)
          </span>
        ),
      },
    ];

    return (
      <Dropdown
        menu={{ items: langItems }}
        placement="bottomRight"
        trigger={["click"]}
      >
        <Button
          type="text"
          style={{
            color: themeMode === "light" ? "#141414" : "#fff",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            fontWeight: "bold",
            fontSize: "14px",
            padding: "4px 8px",
          }}
        >
          <GlobalOutlined style={{ fontSize: "18px" }} />
          <span>{activeLanguage === "thTH" ? "TH" : "EN"}</span>
        </Button>
      </Dropdown>
    );
  };

  return (
    <>
      <Header
        className={"header-layout"}
        style={{
          background: themeMode === "light" ? "#F3F3F1" : "#141414",
          position: "fixed",
          top: "0",
          zIndex: "1000",
          width: "100%",
          borderBottom: "1.7px solid #CECECE",
          height: "70px",
        }}
      >
        {/* Role change modal - only when logged in */}
        {!isTokenExpired && (
          <Modal open={isModal} closable={false} footer={false}>
            <div style={{ padding: "1rem 0rem" }}>
              <Row justify={"center"}>
                <Col style={{ textAlign: "center" }}>
                  <span style={{ fontSize: "18pt", fontWeight: "bold" }}>
                    สิทธิ์การใช้งานของคุณ
                    {typeModal == 1 ? "ในระบบ" : "ในกิจกรรม"} <br />
                    มีการเปลี่ยนแปลง!
                  </span>
                </Col>
              </Row>
              <Row justify={"center"} style={{ marginTop: "1rem" }}>
                <Col>
                  <Button
                    type="primary"
                    style={{ height: "40px" }}
                    onClick={handleClickModal}
                  >
                    <span style={{ fontSize: "12pt" }}>
                      {typeModal == 1 ? "เข้าสู่ระบบใหม่" : "โหลดหน้าใหม่"}
                    </span>
                  </Button>
                </Col>
              </Row>
            </div>
          </Modal>
        )}

        {/* === OLD LAYOUT (Logo Center, Language Left) — commented out ===
        <Row
          className="w-100 h-100"
          justify="space-between"
          align="middle"
          gutter={16}
          style={{ height: "100%" }}
        >
          <Col xs={0} sm={0} md={8} lg={8}>
            <Row align="middle" gutter={16}>
              <Col>
                <LanguageSelector />
              </Col>
            </Row>
          </Col>
          <Col xs={12} sm={12} md={8} lg={8} className="imageheader">
            ...Logo Center...
          </Col>
          <Col xs={0} sm={0} md={8} lg={8}>
            ...Right Actions...
          </Col>
          <Col xs={12} sm={12} md={0} lg={0} style={{ textAlign: "right" }}>
            ...Hamburger...
          </Col>
        </Row>
        === END OLD LAYOUT === */}

        {/* === OLD LAYOUT v2: Logo Left, Actions Right (no center nav) — commented out ===
        <Row
          className="w-100 h-100"
          justify="space-between"
          align="middle"
          gutter={16}
          style={{ height: "100%" }}
        >
          <Col xs={12} sm={12} md={6} lg={5} className="imageheader">
            Logo here...
          </Col>
          <Col xs={0} sm={0} md={18} lg={19}>
            <Row align="middle" justify="end" gutter={[16, 0]}>
              <Col><LanguageSelectorIcon /></Col>
              isTokenExpired ? Login Button : Notification + Profile + Avatar Dropdown
            </Row>
          </Col>
          <Col xs={12} sm={12} md={0} lg={0} style={{ textAlign: "right" }}>
            Hamburger
          </Col>
        </Row>
        === END OLD LAYOUT v2 === */}

        {/* === OLD LAYOUT v3: Logo Left | Nav Menu Center (col-based, ดูเอียงเพราะ col ซ้าย-ขวาไม่เท่า) ===
        <Row className="w-100 h-100" align="middle" style={{ height: "100%", flexWrap: "nowrap" }}>
          <Col xs={12} sm={12} md={4} lg={3} className="imageheader" style={{ flexShrink: 0 }}>Logo</Col>
          <Col xs={0} sm={0} md={13} lg={15} style={{ overflow: "hidden" }}>Nav Menu</Col>
          <Col xs={0} sm={0} md={7} lg={6} style={{ flexShrink: 0 }}>Actions</Col>
          <Col xs={12} sm={12} md={0} lg={0} style={{ textAlign: "right" }}>Hamburger</Col>
        </Row>
        === END OLD LAYOUT v3 === */}

        {/* === NEW LAYOUT v4: Logo Left | Nav Menu (position:absolute, truly centered) | Actions Right === */}
        <div style={{ position: "relative", display: "flex", alignItems: "center", height: "100%", width: "100%" }}>

          {/* Logo - Left (zIndex เพื่อให้อยู่เหนือ nav absolute) */}
          <div style={{ position: "relative", zIndex: 1, flexShrink: 0 }} className="imageheader">
            {isTokenExpired ? (
              <Image
                src={Logobentch}
                style={{ cursor: "pointer", height: "50px", width: "auto" }}
                preview={false}
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate("/");
                  window.location.reload();
                }}
              />
            ) : (
              <a href="/">
                <Image
                  src={Logobentch}
                  style={{ cursor: "pointer", height: "50px", width: "auto" }}
                  preview={false}
                  onClick={() => navigate("/")}
                />
              </a>
            )}
          </div>

          {/* Navigation Menu - Absolutely centered on page (desktop only) */}
          <div
            className="header-nav-center"
            style={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 0,
              display: "flex",
              alignItems: "center",
              width: "max-content", // ให้ container กว้างตาม content → rc-overflow ไม่ซ่อน items
            }}
          >
            {/* --- OLD: Ant Design <Menu> ใช้ rc-overflow → ซ่อน items เป็น "..." ---
            <Menu
              theme="light"
              mode="horizontal"
              selectedKeys={[location.pathname]}
              style={{
                background: themeMode === "light" ? "#F3F3F1" : "#141414",
                borderBottom: "none",
                whiteSpace: "nowrap",
                width: "max-content",
                overflow: "visible",
              }}
              items={menu}
              onClick={(info) => {
                navigate(info.keyPath[0]);
                window.scrollTo(0, 0);
              }}
            />
            --- END OLD --- */}

            {/* Custom NavMenu: render ตรงๆ ไม่มี rc-overflow → แสดงครบทุก item */}
            <div style={{ display: "flex", alignItems: "center", height: "64px" }}>
              {menu.map((item: any) => {
                const isActive =
                  location.pathname === item.key ||
                  location.pathname.startsWith(item.key + "/");
                const baseStyle = {
                  color: isActive
                    ? "#00215E"
                    : themeMode === "light"
                    ? "#141414"
                    : "#fff",
                  borderBottom: isActive
                    ? "2px solid #00215E"
                    : "2px solid transparent",
                  borderRadius: 0,
                  padding: "0 12px",
                  fontSize: "14px",
                  height: "64px",
                  lineHeight: "64px",
                  cursor: "pointer",
                  background: "transparent",
                  border: "none",
                  display: "inline-flex",
                  alignItems: "center",
                  whiteSpace: "nowrap" as const,
                  transition: "color 0.2s",
                  gap: "6px",
                };
                if (item.children && item.children.length > 0) {
                  return (
                    <Dropdown
                      key={item.key}
                      menu={{
                        items: item.children.map((child: any) => ({
                          key: child.key || child.path,
                          label: (
                            <span
                              onClick={() => {
                                navigate(child.key || child.path);
                                window.scrollTo(0, 0);
                              }}
                            >
                              {child.icon && (
                                <span style={{ marginRight: 8 }}>
                                  {child.icon}
                                </span>
                              )}
                              {child.label}
                            </span>
                          ),
                        })),
                      }}
                      placement="bottomCenter"
                    >
                      <span style={baseStyle}>
                        {item.icon}
                        {item.label}
                      </span>
                    </Dropdown>
                  );
                }
                return (
                  <span
                    key={item.key}
                    style={baseStyle}
                    onClick={() => {
                      navigate(item.key);
                      window.scrollTo(0, 0);
                    }}
                  >
                    {item.icon}
                    {item.label}
                  </span>
                );
              })}
            </div>
          </div>

          {/* Right-side Actions - pushed to far right (zIndex เพื่ออยู่เหนือ nav) */}
          <div style={{ position: "relative", zIndex: 1, marginLeft: "auto", flexShrink: 0 }}>

            {/* Desktop Actions */}
            <Row align="middle" justify="end" gutter={[16, 0]} className="desktop-menu">
              {isTokenExpired ? (
                <>
                  {/* Language selector for non-logged-in users */}
                  <Col>
                    <LanguageSelectorIcon />
                  </Col>
                  <Col>
                    <Button
                      style={{
                        backgroundColor: themeMode === "light" ? "black" : "#fff",
                        color: themeMode === "light" ? "#fff" : "black",
                        fontSize: "18px",
                        width: "auto",
                      }}
                      className="loganime"
                      size="large"
                      onClick={() => setIsLoginModalOpen(true)}
                    >
                      {t("Login")}
                    </Button>
                  </Col>
                </>
              ) : (
                <>
                  <Col style={{ display: "flex" }}>
                    <Notification />
                  </Col>
                  <Col>
                    <Row align={"middle"}>
                      <Profile
                        form={form}
                        isProfileOpen={isProfileOpen}
                        onClose={() => {
                          setIsProfileOpen(false);
                          setIsEdit(false);
                          setPasswordFormVisible(false);
                          form.resetFields();
                        }}
                        isEdit={isEdit}
                        setIsEdit={setIsEdit}
                        passwordFormVisible={passwordFormVisible}
                        setPasswordFormVisible={setPasswordFormVisible}
                        userData={userData}
                        getProfile={getProfile}
                      />
                    </Row>
                  </Col>
                  {/* Avatar dropdown includes Language + Profile + Logout */}
                  <Col>
                    <Dropdown
                      menu={{ items: dropdownItems }}
                      placement="bottomRight"
                    >
                      <Row
                        className="h-100 w-100"
                        align={"middle"}
                        style={{ cursor: "pointer" }}
                      >
                        <Avatar
                          src={userData ? userData.profile_img : null}
                          icon={<UserOutlined />}
                        />
                        <div style={{ width: "120px" }}>
                          <span
                            style={{ marginLeft: "10px" }}
                            className="display-profile"
                          >
                            {userData ? userData.user_name : null}
                          </span>
                        </div>
                      </Row>
                    </Dropdown>
                  </Col>
                </>
              )}
            </Row>

            {/* Hamburger Menu - Mobile */}
            <div className="mobile-menu-btn">
              <Button
                icon={<MenuOutlined style={{ fontSize: "18px" }} />}
                onClick={() => setIsDrawerOpen(true)}
              />
            </div>

          </div>

        </div>

        {/* Drawer for small screens */}
        <Drawer
          title={
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Image src={Logobentch} style={{ height: "32px", width: "auto" }} preview={false} />
              <span style={{ fontWeight: 700, fontSize: "16px" }}>AI Benchmark</span>
            </div>
          }
          placement="right"
          onClose={() => setIsDrawerOpen(false)}
          open={isDrawerOpen}
          width={280}
          styles={{
            body: { padding: 0, display: "flex", flexDirection: "column", height: "100%" },
          }}
        >
          {/* Navigation Menu */}
          <div style={{ flex: 1, overflowY: "auto" }}>
            <Menu
              mode="inline"
              selectedKeys={[location.pathname]}
              style={{
                border: "none",
                background: "transparent",
                fontSize: "15px",
              }}
              items={menu}
              onClick={(info) => {
                navigate(info.keyPath[0]);
                window.scrollTo(0, 0);
                setIsDrawerOpen(false);
              }}
            />
          </div>

          {/* Bottom section */}
          <div
            style={{
              borderTop: "1px solid #f0f0f0",
              padding: "16px",
              display: "flex",
              flexDirection: "column",
              gap: "12px",
            }}
          >
            {/* Language */}
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <LanguageSelectorIcon />
            </div>

            <Divider style={{ margin: "4px 0" }} />

            {isTokenExpired ? (
              <Button
                block
                size="large"
                style={{
                  backgroundColor: themeMode === "light" ? "#141414" : "#fff",
                  color: themeMode === "light" ? "#fff" : "#141414",
                  fontWeight: 600,
                  border: "none",
                  borderRadius: "8px",
                }}
                onClick={() => {
                  setIsLoginModalOpen(true);
                  setIsDrawerOpen(false);
                }}
              >
                {t("Login")}
              </Button>
            ) : (
              <>
                {/* User info */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    padding: "8px 12px",
                    background: themeMode === "light" ? "#f5f5f5" : "#1f1f1f",
                    borderRadius: "10px",
                  }}
                >
                  <Avatar
                    size={36}
                    src={userData ? userData.profile_img : null}
                    icon={<UserOutlined />}
                  />
                  <div style={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
                    <span style={{ fontWeight: 600, fontSize: "14px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {userData?.user_name}
                    </span>
                    <span style={{ fontSize: "12px", color: "#888", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      {userData?.role_name}
                    </span>
                  </div>
                </div>

                {/* Profile + Logout */}
                <Button
                  block
                  onClick={() => {
                    setIsProfileOpen(true);
                    setIsDrawerOpen(false);
                  }}
                  style={{ borderRadius: "8px", textAlign: "left" }}
                >
                  <UserOutlined style={{ marginRight: "8px" }} />
                  {t("Profile")}
                </Button>
                <Button
                  block
                  danger
                  style={{ borderRadius: "8px", textAlign: "left" }}
                  onClick={() => {
                    try {
                      auth.logout();
                      logoutSocket();
                    } catch (e) {
                      console.error(e);
                    }
                  }}
                >
                  <LogoutOutlined style={{ marginRight: "8px" }} />
                  {t("Logout")}
                </Button>
              </>
            )}
          </div>
        </Drawer>
      </Header>

      {/* Login Modal - only when not logged in */}
      {isTokenExpired && (
        <Modal
          title={t("Login")}
          open={isLoginModalOpen}
          style={{ top: 20 }}
          footer={null}
          onCancel={() => setIsLoginModalOpen(false)}
        >
          <Form
            layout="vertical"
            form={loginForm}
            name="login-form"
            initialValues={{ autoLogin: true }}
            style={{ padding: "20px" }}
            onFinish={handleLogin}
          >
            <Col style={{ textAlign: "center", marginBottom: "20px" }}>
              <img
                src={themeMode === "dark" ? LogoWhite : LogoBg}
                height={100}
              />
            </Col>

            <Form.Item
              label={t("Email") + " / " + t("Username") + " * "}
              name="email"
              rules={[
                { type: "string", message: "The input is not a valid e-mail" },
                {
                  required: true,
                  message: "Please input your email or username!",
                },
              ]}
            >
              <Input
                prefix={<UserOutlined className="site-form-item-icon" />}
                placeholder="Email or username"
              />
            </Form.Item>

            <Form.Item
              label={t("password") + " * "}
              name="password"
              rules={[
                { required: true, message: "Please input your password!" },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
                placeholder="Password"
              />
            </Form.Item>

            <Form.Item>
              <a
                onClick={() => {
                  setIsLoginModalOpen(false);
                  navigate("/user/forgot/reset");
                }}
              >
                {t("Forgot password")}
              </a>
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                loading={submitting}
                style={{
                  background:
                    "linear-gradient(90deg, rgba(137,33,107,1) 0%, rgba(137,33,107,1) 35%, rgba(218,68,83,1) 100%)",
                  padding: "0px",
                }}
              >
                {t("Login")}
              </Button>

              <Form.Item className="center-text">
                <span>{t("Don't have an account")} </span>
                <a
                  onClick={() => {
                    setIsLoginModalOpen(false);
                    navigate("/user/register/new");
                  }}
                >
                  {t("Sign Up")}
                </a>
              </Form.Item>
            </Form.Item>
          </Form>
        </Modal>
      )}
    </>
  );
};

export default HeaderLayout;
